// extracted by mini-css-extract-plugin
export default {"averageSalePrice":"ONpiItYdRuTWSy7CpRwA","tooltip":"uUb7QhB3piTXeJCCbuqs"};